import { createReducer } from '@reduxjs/toolkit';

import * as MenuBarActions from './actions';
import { IMenuBarState } from './interfaces';
import { Constants } from './constants';

const initialMenuBarState: IMenuBarState = {
    selectMailItemsAction: null,
    selectedFolderMenubarItemAction: null,
    selectedMenuButtonAction: null,
    touchSelectActive: false,
    enablePrint: true,
    disableReadUnreadButton: false,
    disableAddRemoveFlagButton: false,
    disableMoveToFolderMenuItem: false,
};

export const menubarReducer = createReducer(initialMenuBarState, {
    [Constants.MENUBAR_SELECTMAILS]: (draftState, action: ReturnType<typeof MenuBarActions.selectMailsAction>) => {
        draftState.selectMailItemsAction = action.payload.selectedAction;
    },

    [Constants.MENUBAR_SET_ENABLE_DISABLE_MOVE_TO_FOLDER_MENU_ITEM]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setEnableDisableMoveToFolderMenuItem>
    ) => {
        draftState.disableMoveToFolderMenuItem = action.payload.disable;
    },

    [Constants.MENUBAR_SET_ENABLE_DISABLE_READUNREAD_BUTTON]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setEnableDisableReadUnreadButton>
    ) => {
        draftState.disableReadUnreadButton = action.payload.disable;
    },

    [Constants.MENUBAR_SET_ENABLE_DISABLE_ADDREMOVE_FLAG_BUTTON]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setEnableDisableAddRemoveFlagButton>
    ) => {
        draftState.disableAddRemoveFlagButton = action.payload.disable;
    },

    [Constants.MENUBAR_SET_ENABLE_PRINT_BUTTON]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setEnablePrint>
    ) => {
        draftState.enablePrint = action.payload.enable;
    },

    [Constants.MENUBAR_SET_SELECTED_BUTTON_ACTION]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setSelectedMenuBarButtonAction>
    ) => {
        draftState.selectedMenuButtonAction = action.payload.buttonAction;
    },

    [Constants.MENUBAR_SET_SELECTED_ITEM_FOLDER_ACTION]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setSelectedFolderMenuBarItemAction>
    ) => {
        draftState.selectedFolderMenubarItemAction = action.payload.itemAction;
    },

    [Constants.MENUBAR_SET_TOUCH_SELECT_ACTIVE]: (
        draftState,
        action: ReturnType<typeof MenuBarActions.setTouchSelectActive>
    ) => {
        draftState.touchSelectActive = action.payload.active;
    },
});
